import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../identidad/Logo.png";
const apiUrl = process.env.REACT_APP_API_BASE_URL;

const DashboardAuditoria = () => {
  const navigate = useNavigate();
  const [programas, setProgramas] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  if (localStorage.getItem("rol") !== "auditoria") {
    navigate("/");
    localStorage.clear();
  }

  useEffect(() => {
    const fetchProgramas = async () => {
      try {
        let response = await fetch(`${apiUrl}/Programa/Get`,{
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'apiKey': localStorage.getItem("apiKey")

          }});
        if (response.ok) {
          let data = await response.json();
          setProgramas(data);
        } else {
          console.error("Error al obtener programas");
        }
      } catch (error) {
        console.error("Error en la solicitud", error);
      }
    };
    fetchProgramas();
  }, []);

  const mostrarAdelantos = (idPrograma) => {
    navigate(`/DashboardPrograma/${idPrograma}`);
  };
  const mostrarTodosAdelantos = () => {
    navigate(`/adelantos`);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredProgramas = programas.filter((programa) =>
    programa.nombre.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container " style={{ marginTop: "4rem" }}>
      <h2 className="p-3">Dashboard Auditoria, Hola {localStorage.getItem("nombre")}!!</h2>
      <div className="mb-4">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar programa..."
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>

      <div className="row justify-content-center">
        <div className="col-md-4 mb-4 card shadow-sm">
          {" "}
          <button
            className="card-body d-flex flex-column justify-content-center align-items-center btn btn-light"
            onClick={() => mostrarTodosAdelantos()}
          >
            <img
              src={logo}
              alt="Logo"
              style={{ maxWidth: "200px", maxHeight: "200px" }}
            />
            <h5 className="card-title">Todos los Adelantos</h5>
          </button>
        </div>

        {filteredProgramas.map((item) => (

          <div key={item.id} className="col-md-4 mb-4">
            <div className="card h-100 shadow-sm">
              <button
                className="card-body d-flex flex-column justify-content-center align-items-center btn btn-light"
                onClick={() => mostrarAdelantos(item.id)}
              >
                <img
                  src={`data:${item.logoMimeType};base64,${item.logo}`}
                  alt="Logo"
                  style={{ maxWidth: "200px", maxHeight: "200px" }}
                />

                <h5 className="card-title">{item.nombre}</h5>
              </button>
            </div>
          </div>
          
        ))}

        {filteredProgramas.length === 0 && (
          <div className="alert alert-primary" role="alert">
            No existe ningun programa
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardAuditoria;
